import {
    IMPACT_FILTER_REQUESTED,
    IMPACT_FILTER_SUCCEEDED,
    IMPACT_FILTER_FAILED,
    RESET_LITTERS,
    IMPACT_FILTER_ZOOM_CHANGED_REQUESTED,
} from './constants';

const initialState = {
    // denotes the currently selected impact box filter radio option
    selectedFilter: null,

    // The litters to be shown on map
    impactLitters: [],

    // indicates whether the litters have been requested or not
    litterRequested: true,
    hasMoreData: false,
    // denotes any error that occurs within the `map` context
    error: null,
};

export default function(state = initialState, action) {
    switch (action.type) {
        case IMPACT_FILTER_ZOOM_CHANGED_REQUESTED: {
            const { zoom, dimension } = action;
            return {
                ...state,
                zoom,
                dimension,
            };
        }
        case IMPACT_FILTER_REQUESTED: {
            const { selectedFilter } = action;
            return {
                ...state,
                selectedFilter,
                litterRequested: true,
            };
        }
        case IMPACT_FILTER_SUCCEEDED: {
            const { impactLitters, hasMoreData } = action;
            return {
                ...state,
                litterRequested: false,
                hasMoreData,
                impactLitters: impactLitters,
            };
        }
        case IMPACT_FILTER_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                litterRequested: false,
            };
        }
        case RESET_LITTERS: {
            return {
                ...state,
                impactLitters: [],
            };
        }
        default:
            return state;
    }
}
